import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Link,
  withRouter,
} from 'react-router-dom';
import {
  UncontrolledTooltip,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import {
  showModal,
  showModalTop,
} from '../actions';
import { showConfirmationModal } from '../actions/App';
import {
  fetchSidebarCollectionFiles,
  updateSidebarCollection,
  setSidebarCollection,
  removeFilesFromCollection,
  removeFilesFromSidebarCollectionFilesList,
  removeSidebarCollection,
  updateCollectionOnCollectionsList,
  deleteCollections,
} from '../actions/Collections';
import { removeFilesFromFilesList } from '../actions/Files';

import { isArchive } from '../helpers/App';
import { userCan } from '../helpers/Auth';
import { getParentCollection } from '../helpers/Collections';
import { addFlashMessage } from '../helpers/FlashMessages';
import { getUserSetting } from '../helpers/Settings';

import CollectionPreviewFile from './CollectionPreviewFile';
import CollectionSelectModal from './CollectionSelectModal';

import ErrorBoundary from './ErrorBoundary';
import Loading from './Loading';

class CollectionPreview extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionSelectOpen: false,
    };

    this.handleRemoveFile = this.handleRemoveFile.bind(this);
    this.handleDownloadCollection = this.handleDownloadCollection.bind(this);
    this.handleDownloadRequest = this.handleDownloadRequest.bind(this);
    this.handleRequestDownloadCollection = this.handleRequestDownloadCollection.bind(this);
    this.handleShareCollection = this.handleShareCollection.bind(this);
    this.openCollectionEditModal = this.openCollectionEditModal.bind(this);
    this.openCollectionSelectModal = this.openCollectionSelectModal.bind(this);
    this.closeCollectionSelectModal = this.closeCollectionSelectModal.bind(this);
    this.openCollectionCreateModal = this.openCollectionCreateModal.bind(this);
    this.updateCollectionOnList = this.updateCollectionOnList.bind(this);
    this.handleNewCollection = this.handleNewCollection.bind(this);
    this.handleChangeAccess = this.handleChangeAccess.bind(this);
    this.handleChangeOwner = this.handleChangeOwner.bind(this);
    this.handleArchive = this.handleArchive.bind(this);
    this.handleCollectionSelect = this.handleCollectionSelect.bind(this);
    this.handleCollectionClear = this.handleCollectionClear.bind(this);
  }

  componentDidMount() {
    this.restoreLastCollection();
  }

  shouldComponentUpdate(prevProps, prevState) {
    const { collectionSelectOpen } = this.state;
    const { collectionSelectOpen: prevCollectionSelectOpen } = prevState;
    const {
      location,
      sidebarCollectionUpdate,
      sidebarCollection,
      sidebarCollectionFiles,
      sidebarCollectionFilesLoading,
      sidebarCollectionOpen,
      collectionGroups,
      collectionGroupsLoading,
    } = this.props;
    const {
      location: prevLocation,
      sidebarCollectionUpdate: prevSidebarCollectionUpdate,
      sidebarCollection: prevSidebarCollection,
      sidebarCollectionFiles: prevSidebarCollectionFiles,
      sidebarCollectionFilesLoading: prevSidebarCollectionFilesLoading,
      sidebarCollectionOpen: prevSidebarCollectionOpen,
      collectionGroups: prevCollectionGroups,
    } = prevProps;

    if (
      (
        location.pathname !== prevLocation.pathname &&
        isArchive(location.pathname) !== isArchive(prevLocation.pathname)
      ) ||
      sidebarCollectionUpdate !== prevSidebarCollectionUpdate ||
      sidebarCollection !== prevSidebarCollection ||
      sidebarCollectionFiles.length !== prevSidebarCollectionFiles.length ||
      sidebarCollectionFilesLoading !== prevSidebarCollectionFilesLoading ||
      sidebarCollectionOpen !== prevSidebarCollectionOpen ||
      (collectionGroupsLoading && collectionGroups.length !== prevCollectionGroups.length) ||
      collectionSelectOpen !== prevCollectionSelectOpen
    ) {
      return true;
    }

    return false;
  }

  componentDidUpdate() {
    const { sidebarCollectionUpdate } = this.props;

    if (sidebarCollectionUpdate) {
      this.loadSidebarCollectionFiles();
    } else {
      this.restoreLastCollection();
    }
  }

  loadSidebarCollectionFiles() {
    const {
      dispatch,
      sidebarCollection,
    } = this.props;

    if (sidebarCollection) {
      dispatch(fetchSidebarCollectionFiles(sidebarCollection.uuid));
    }
  }

  restoreLastCollection() {
    const {
      dispatch,
      sidebarCollection,
    } = this.props;

    if (sidebarCollection) {
      return;
    }

    const lastCollection = getUserSetting('sidebar_collection');
    if (lastCollection) {
      dispatch(updateSidebarCollection(lastCollection));
    }
  }

  handleRemoveFile(file) {
    const {
      intl,
      dispatch,
      collection,
      sidebarCollection,
    } = this.props;

    dispatch(removeFilesFromCollection(sidebarCollection.uuid, { files: [file] }));
    dispatch(removeFilesFromSidebarCollectionFilesList([{ uuid: file }]));
    if (collection && collection.uuid === sidebarCollection.uuid) {
      dispatch(removeFilesFromFilesList([{ uuid: file }]));
    }
    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'File has been removed from Collection' }),
    });
  }

  handleDownloadCollection(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      collections: [collection],
      backdrop: true,
    }));
  }

  handleDownloadRequest(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      files: collection.request.files,
      collections: [collection],
      requestUuid: collection.request.uuid,
      availableFileSizes: collection.request.file_sizes.map(fs => (`${fs.id}`)),
      backdrop: true,
    }));
  }

  handleRequestDownloadCollection(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('DownloadModal', {
      className: 'modal-download',
      collections: [collection],
      backdrop: true,
      request: true,
    }));
  }

  handleShareCollection(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('ShareModal', {
      className: 'modal-share modal-share-file',
      collections: [collection],
    }));
  }

  openCollectionEditModal(params) {
    const { dispatch } = this.props;
    dispatch(showModal('CollectionEditModal', params));
  }

  updateCollectionOnList(collection) {
    const { dispatch } = this.props;
    dispatch(setSidebarCollection(collection, false));
    return dispatch(updateCollectionOnCollectionsList(collection));
  }

  handleNewCollection(collection) {
    const { dispatch } = this.props;
    dispatch(setSidebarCollection(collection));
  }

  handleDeleteCollection(collection) {
    const { intl, dispatch } = this.props;
    const modalParams = {
      title: intl.formatMessage({ defaultMessage: 'Are you sure?' }),
      text: intl.formatMessage({
        defaultMessage: `Are you sure you want to delete this Collection?
        Doing this will not delete the files within the Collection,
        but the Collection will be permanently removed.`,
      }),
      onConfirm: () => (
        dispatch(deleteCollections({
          collectionUuidList: [collection.uuid],
        }))
      ),
    };
    dispatch(showConfirmationModal(modalParams));
  }

  handleChangeOwner(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('ChangeOwnerModal', {
      className: 'modal-change-owner',
      collections: [collection],
    }));
  }

  handleChangeAccess(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('AccessModal', {
      className: 'modal-access modal-file-access',
      collections: [collection],
    }));
  }

  handleArchive(collection) {
    const { dispatch } = this.props;
    dispatch(showModal('ArchiveModal', {
      className: 'modal-archive modal-file-archive',
      collections: [collection],
      action: collection.archived ? 'unarchive' : 'archive',
    }));
  }

  handleCollectionSelect(collection) {
    const { dispatch } = this.props;
    dispatch(setSidebarCollection(collection));
    dispatch(updateSidebarCollection(collection));
  }

  handleCollectionClear() {
    const { dispatch } = this.props;
    dispatch(removeSidebarCollection());
  }

  openCollectionSelectModal() {
    this.setState({ collectionSelectOpen: true });
  }

  closeCollectionSelectModal() {
    this.setState({ collectionSelectOpen: false });
  }

  openCollectionCreateModal(e) {
    e.preventDefault();

    const {
      dispatch,
      collection: currentCollection,
    } = this.props;
    dispatch(showModalTop('CollectionEditModal', {
      className: 'modal-edit-collection',
      inOverlay: true,
      top: true,
      parentCollection: currentCollection,
      afterCreateCollection: (collection) => {
        this.handleCollectionSelect(collection);
      },
    }));
  }

  render() {
    const { collectionSelectOpen } = this.state;
    const {
      intl,
      sidebarCollection,
      sidebarCollectionFiles,
      sidebarCollectionFilesLoading,
      sidebarCollectionOpen,
    } = this.props;

    if (!sidebarCollectionOpen || isArchive()) {
      return null;
    }

    return (
      <div className="collection-preview">
        <div className="collection-preview-header">
          <div>
            {intl.formatMessage({ defaultMessage: 'Collection Builder' })}
          </div>
          <div className="collection-preview-header-actions">
            <a
              id="collection-preview-select"
              href="#select"
              onClick={this.openCollectionSelectModal}
            >
              <i className="fas fa-search" />
            </a>
            <UncontrolledTooltip target="collection-preview-select" fade={false}>
              {intl.formatMessage({ defaultMessage: 'Select Collection' })}
            </UncontrolledTooltip>
            {userCan('collection.create') && (
              <>
                <a
                  id="collection-preview-create-new-collection"
                  href="#create"
                  onClick={this.openCollectionCreateModal}
                >
                  <i className="fas fa-plus" />
                </a>
                <UncontrolledTooltip target="collection-preview-create-new-collection" fade={false}>
                  {intl.formatMessage({ defaultMessage: 'New Collection' })}
                </UncontrolledTooltip>
              </>
            )}
          </div>
        </div>
        <div className="collection-preview-content">
          <div className="collection-preview-form">
            <div className="collection-preview-select">
              {sidebarCollection ? (
                <>
                  <Link to={`/collections/${sidebarCollection.uuid}`} className="collection-preview-link">
                    <i className="far fa-layer-group" />
                    <span>
                      {sidebarCollection.name}
                    </span>
                  </Link>
                  <a
                    id="collection-preview-clear"
                    href="#clear"
                    onClick={this.handleCollectionClear}
                  >
                    <i className="fas fa-xmark" />
                  </a>
                  <UncontrolledTooltip fade={false} target="collection-preview-clear">
                    {intl.formatMessage({ defaultMessage: 'Clear Collection' })}
                  </UncontrolledTooltip>
                </>
              ) : (
                <span>{intl.formatMessage({ defaultMessage: 'No collection selected' })}</span>
              )}
            </div>
            <div className="collection-preview-actions">
              {sidebarCollectionFiles.length > 0 && (
                <span className="collection-preview-files">
                  {intl.formatMessage({
                    defaultMessage: '{count} {count, plural, one {file} other {files}}',
                  }, { count: sidebarCollectionFiles.length })}
                </span>
              )}
              {(sidebarCollection &&
                sidebarCollectionFiles.length === 0 &&
                !sidebarCollectionFilesLoading
              ) && (
                <span className="collection-preview-files">
                  {intl.formatMessage({ defaultMessage: 'No files' })}
                </span>
              )}
              {(sidebarCollection && sidebarCollection.capabilities) && (
                <ul className="collection-preview-actions-list">
                  {sidebarCollectionFiles.length > 0 && (
                    <>
                      {((userCan('collection.download', sidebarCollection) || userCan('collection.request_download', sidebarCollection)) && sidebarCollection.request) && (
                        <li>
                          <a
                            href="#download-requested"
                            id={`CollectionActionDownloadRequest-${sidebarCollection.uuid}`}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleDownloadRequest(sidebarCollection);
                            }}
                          >
                            <i className="far fa-download" />
                          </a>
                          <UncontrolledTooltip placement="bottom" target={`CollectionActionDownloadRequest-${sidebarCollection.uuid}`}>
                            {intl.formatMessage({ defaultMessage: 'Download' })}
                          </UncontrolledTooltip>
                        </li>
                      )}
                      {userCan('collection.request_download', sidebarCollection) && (
                        <li>
                          <a
                            href="#request-download"
                            id={`SidebarCollectionActionRequestDownload-${sidebarCollection.uuid}`}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleRequestDownloadCollection(sidebarCollection);
                            }}
                          >
                            <i className="far fa-cart-arrow-down" />
                          </a>
                          <UncontrolledTooltip placement="bottom" target={`SidebarCollectionActionRequestDownload-${sidebarCollection.uuid}`}>
                            {intl.formatMessage({ defaultMessage: 'Request Download' })}
                          </UncontrolledTooltip>
                        </li>
                      )}
                      {(userCan('collection.download', sidebarCollection) && !sidebarCollection.request) && (
                        <li>
                          <a
                            href="#download"
                            id={`SidebarCollectionActionDownload-${sidebarCollection.uuid}`}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleDownloadCollection(sidebarCollection);
                            }}
                          >
                            <i className="far fa-download" />
                          </a>
                          <UncontrolledTooltip placement="bottom" target={`SidebarCollectionActionDownload-${sidebarCollection.uuid}`}>
                            {intl.formatMessage({ defaultMessage: 'Download' })}
                          </UncontrolledTooltip>
                        </li>
                      )}
                      {userCan('collection.change_access', sidebarCollection) ? (
                        <li>
                          <a
                            href="#access"
                            id={`SidebarCollectionActionAccess-${sidebarCollection.uuid}`}
                            onClick={(e) => {
                              e.preventDefault();
                              this.handleChangeAccess(sidebarCollection.uuid);
                            }}
                          >
                            <i className="far fa-share-alt" />
                          </a>
                          <UncontrolledTooltip placement="bottom" target={`SidebarCollectionActionAccess-${sidebarCollection.uuid}`}>
                            {intl.formatMessage({ defaultMessage: 'Access & Share' })}
                          </UncontrolledTooltip>
                        </li>
                      ) : (
                        <>
                          {(userCan('collection.share', sidebarCollection) && !sidebarCollection.archived) && (
                            <li>
                              <a
                                href="#share"
                                id={`SidebarCollectionActionShare-${sidebarCollection.uuid}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.handleShareCollection({
                                    ...sidebarCollection,
                                    featured_file:
                                      sidebarCollection.featured_file || sidebarCollectionFiles[0],
                                  });
                                }}
                              >
                                <i className="far fa-share-alt" />
                              </a>
                              <UncontrolledTooltip placement="bottom" target={`SidebarCollectionActionShare-${sidebarCollection.uuid}`}>
                                {intl.formatMessage({ defaultMessage: 'Share a link' })}
                              </UncontrolledTooltip>
                            </li>
                          )}
                        </>
                      )}
                    </>
                  )}
                  {userCan('collection.edit', sidebarCollection) && (
                    <li className="action-more">
                      <UncontrolledDropdown>
                        <DropdownToggle nav className="options">
                          <i className="far fa-ellipsis-h" />
                        </DropdownToggle>
                        <DropdownMenu right>
                          {userCan('collection.edit', sidebarCollection) && (
                            <DropdownItem
                              onClick={() => {
                                this.openCollectionEditModal({
                                  className: 'modal-edit-collection',
                                  collection: sidebarCollection,
                                  parentCollection: getParentCollection(sidebarCollection),
                                  afterCreateCollection: this.updateCollectionOnList,
                                });
                              }}
                            >
                              <i className="fas fa-edit" />
                              {intl.formatMessage({ defaultMessage: 'Edit' })}
                            </DropdownItem>
                          )}
                          {userCan('collection.change_owner', sidebarCollection) && (
                            <DropdownItem
                              onClick={() => {
                                this.handleChangeOwner(sidebarCollection);
                              }}
                            >
                              <i className="fas fa-user-circle" />
                              {intl.formatMessage({ defaultMessage: 'Change Owner' })}
                            </DropdownItem>
                          )}
                          {userCan('collection.delete', sidebarCollection) && (
                            <DropdownItem
                              onClick={() => {
                                this.handleDeleteCollection(sidebarCollection);
                              }}
                            >
                              <i className="fas fa-trash" />
                              {intl.formatMessage({ defaultMessage: 'Delete' })}
                            </DropdownItem>
                          )}
                          {userCan('collection.archive', sidebarCollection) && (
                            <>
                              <DropdownItem divider />
                              <DropdownItem
                                onClick={() => {
                                  this.handleArchive(sidebarCollection);
                                }}
                              >
                                <i className={`fas fa-${sidebarCollection.archived ? 'box-open' : 'archive'}`} />
                                {
                                  sidebarCollection.archived ?
                                    intl.formatMessage({ defaultMessage: 'Unarchive' }) :
                                    intl.formatMessage({ defaultMessage: 'Archive' })
                                }
                              </DropdownItem>
                            </>
                          )}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </li>
                  )}
                </ul>
              )}
            </div>
          </div>
          <div className="collection-preview-gallery">
            {sidebarCollectionFilesLoading ? (
              <Loading className="gray" />
            ) : (
              <ErrorBoundary>
                {sidebarCollectionFiles.length > 0 && (
                  <ul className="collection-preview-gallery-list">
                    {sidebarCollectionFiles.map(file => (
                      <CollectionPreviewFile
                        key={file.uuid}
                        file={file}
                        canUserRemove={sidebarCollection && userCan('collection.remove', sidebarCollection)}
                        handleRemoveFile={this.handleRemoveFile}
                      />
                    ))}
                  </ul>
                )}
              </ErrorBoundary>
            )}
          </div>
        </div>
        <CollectionSelectModal
          modalOpen={collectionSelectOpen}
          enableAddNew={userCan('collection.create')}
          onlyOpenCollections={true}
          handleClose={this.closeCollectionSelectModal}
          handleCollectionSelect={this.handleCollectionSelect}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collection: state.Collections.collection,
  collectionGroups: state.Collections.collectionGroups,
  collectionGroupsLoading: state.Collections.collectionGroupsLoading,
  sidebarCollectionOpen: state.Collections.sidebarCollectionOpen,
  sidebarCollection: state.Collections.sidebarCollection,
  sidebarCollectionFiles: state.Collections.sidebarCollectionFiles,
  sidebarCollectionFilesLoading: state.Collections.sidebarCollectionFilesLoading,
  sidebarCollectionUpdate: state.Collections.sidebarCollectionUpdate,
});

CollectionPreview.propTypes = {
  intl: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  location: PropTypes.object.isRequired,
  collection: PropTypes.object,
  collectionGroups: PropTypes.array.isRequired,
  collectionGroupsLoading: PropTypes.bool.isRequired,
  sidebarCollectionOpen: PropTypes.bool.isRequired,
  sidebarCollection: PropTypes.object,
  sidebarCollectionFiles: PropTypes.array.isRequired,
  sidebarCollectionFilesLoading: PropTypes.bool.isRequired,
  sidebarCollectionUpdate: PropTypes.bool.isRequired,
};

CollectionPreview.defaultProps = {
  collection: null,
  sidebarCollection: null,
};

export default withRouter(connect(mapStateToProps)(injectIntl(CollectionPreview)));
